import React, {Component} from 'react';
import {message, Steps, Table, DatePicker, Select} from 'antd';
import _, {map, isEmpty, orderBy} from 'lodash';
import GoogleMapReact from 'google-map-react';
import moment from 'moment-timezone';
import * as yup from "yup";
import pin from '../../../../Assets/images/pin.png';
import Header from '../../../Common/Component/Header';
import Loader from "../../../Common/Component/Loader";
import Sidebar from '../../../Common/Component/Sidebar';
import {errorHandle} from "../../../Common/errorHandle";
import DataTable from '../../CustomerList/Component/DataTable';
import { convertFirstCharToUppercase } from '../../../../Tools/convertFirstLetterToUppercase';
import CustomerDrawerCollapse from '../../CustomerDetail/Component/CustomDrawer/CustomerDrawerCollapse';
import CustomDrawer from "../../CustomerDetail/Component/CustomDrawer/CustomDrawer";
import { aboutUsData } from "../../../../Assets/data/aboutUsList";

const {Step} = Steps;
const {Option} = Select;

// mapping for cleaning areas
const formattedAreas = {'front yard': 'Front Yard', 'back yard': 'Back Yard',
  'right side': 'Right Side', 'left side': 'Left Side', 'dog run': 'Dog Run', 'fenced area': 'Fenced Area'};

// mapping frequency for hardcoded
const FREQUENCY_MAPPING = {
  weekly: 'Weekly',
  bi_monthly: 'Every Other Week',
  once: 'Just Once',
  twice_weekly: 'Twice Weekly',
  monthly: 'Monthly'
};

// mapping of lead stage
const leadStage = ['new', 'contacted', 'interested', 'customer'];

// mapping of out reach
const outreach = {
  website: 'Website',
  call_center: 'Call Center',
  franchisee: 'Franchisee'
};

// marker pin
const MarkerPin = (props) =>
  <div className="marker_wrapper d-flex align-items-center">
    <img style={{ 'width': '15px' }} src={pin} alt="" className="pin" />
    <div className="pulse"><span style={{'color': 'red', 'whiteSpace': 'nowrap','fontSize': '9px', 'display': 'block','lineHeight': '14px'}}>{props?.address || ''}</span></div>
  </div>;

class LeadDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 0,
      message_count: 0,
      customer: {},
      callLog: {},
      loader: false,
      accountNotes: {},
      enquiryList: {},
      authorizedUser: {},
      leadData: {},
      currentLeadStep: 0,
      callHistoryPagination: { showSizeChanger: false, pageSize: 10, ordering: "", current: 1 },
      next_callback: '',
      notes: '',
      purpose: '',
      contact_method: '',
      errors: {},
      showSidebar: true,
      isExpandPanel: false
    }
  }

  componentDidMount = () => {
    const { history } = this.props;
    const id = history?.location?.state?.query?.id;
    if (id) {
      this.setState({ loader: true });
      this.props.getServiceOrderEnquiry({user__uuid: id, limit: 1}); // get service order enquiry
      this.props.getAuthorizedUserList({user__uuid: id}) // get authorized user list
      this.props.getLeadById(id); //get lead customer data
      this.props.getCallLogList({user__uuid: id}); // get call history
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const {leadData} = this.state;
    this.setState({ loader: false });
    
    // errors
    const errors = {
      ...nextProps?.CustomerList?.errors,
      ...nextProps?.Lead?.errors,
      ...nextProps?.CallLog?.errors
    } || {};
    if (errors && Object.keys(errors).length > 0) {
      if (errors?.detail !== 'Not found.') {
        message.error('Something went wrong', 10);
      }
    }

    ///// errors /////////////////////////
    if (Object.keys(nextProps?.CustomerList?.errors).length > 0 && nextProps?.CustomerList?.errors !== this.props?.CustomerList?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.CustomerList?.errors)
    }

    if (Object.keys(nextProps?.Lead?.errors).length > 0 && nextProps?.Lead?.errors !== this.props?.Lead?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.Lead?.errors)
    }

    if (Object.keys(nextProps?.CallLog?.errors).length > 0 && nextProps?.CallLog?.errors !== this.props?.CallLog?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.CallLog?.errors)
    }
    //////////////////////////////////////

    // get call logs
    if (Object.keys(nextProps?.CallLog?.logList).length > 0) {
      this.setState({ callLog: nextProps?.CallLog?.logList });
    }
    
    // add call logs
    // if (Object.keys(nextProps?.CallLog?.log).length > 0) {
    //   this.setState({ callLog: { ...callLog, results: [...(callLog?.results || []), nextProps?.CallLog?.log] } });
    // }
    
    // get service order
    if (Object.keys(nextProps?.ServiceOrderEnquiry?.enquiryList).length > 0) {
      this.setState({enquiryList: nextProps?.ServiceOrderEnquiry?.enquiryList});
    }
    
    // get authorized user list
    if (Object.keys(nextProps?.AuthorizedUser?.userList).length > 0) {
      this.setState({authorizedUser: nextProps?.authorizedUser?.userList});
    }
    
    // get lead customer data
    if (Object.keys(nextProps?.Lead?.getLead).length > 0) {
      this.setState({leadData: nextProps?.Lead?.getLead, currentLeadStep: leadStage.indexOf(nextProps?.Lead?.getLead?.lead_stage) || 0});
    }

    // add call logs
    if (Object.keys(nextProps?.Lead?.updateLead).length > 0) {
      this.setState({ leadData: { ...leadData, ...nextProps?.Lead?.updateLead}, currentLeadStep: leadStage.indexOf(nextProps?.Lead?.getLead?.lead_stage) || 0 });
    }
  }

  // format phone number
  formatPhoneNumber = (phone) => {
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  // on lead step change
  onLeadStepChange = (step) => {
    const {leadData, enquiryList} = this.state;
    this.setState({loader: true});
    if (!leadData?.address?.[0]?.geo_location) {
      delete leadData?.address?.[0]?.geo_location
    }

    let obj = {uuid: leadData?.uuid,
      is_crm: true,
      first_name: leadData?.first_name,
      last_name: leadData?.last_name,
      address: leadData?.address,
      authorizedUser: leadData?.authorizedUser,
      phone_numbers: leadData?.phone_numbers,
      lead_stage: leadStage[step],
      outreach: leadData?.outreach,
      role: leadStage[step] === 'customer' ? ['customer'] : ['lead']
    }

    if (leadStage[step] === 'customer') {
      Promise.allSettled([this.props.updateServiceOrderEnquiry({uuid: enquiryList?.results?.[0]?.uuid, is_enquiry: false}), setTimeout(() => this.props.updateLeads(obj), 1000)]).then((result) => {
        const isReject = result.filter(x => x.status === "rejected")
        if (isReject?.length > 0) {
          setTimeout(() => errorHandle(isReject?.[0]?.reason), 1000)
        } else {
          if (leadStage[step] === 'customer') {
            this.props.history.replace('/residential')
          }
        }
      })
    } else {
      this.props.updateLeads(obj);
    }

    if (leadStage[step] !== 'customer') {
      setTimeout(() => this.props.getLeadById(leadData?.uuid), 500)
    }
  };

  //Table Order and Pagination
  onCallHistoryTableChange = (pagination) => {
    const { history } = this.props;
    const id = history?.location?.state?.query?.id;

    const {callHistoryPagination} = this.state;
    Object.assign(callHistoryPagination, { current: pagination.current });
    this.setState({
      callHistoryPagination,
      loader: true,
    });

    this.props.getCallLogList({user__uuid: id, offset: ((pagination.current - 1) * pagination?.pageSize), limit: pagination?.pageSize})
  }

  // on call request detail change
  onTextChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
  };
  
  // on clear
  onClear = () => {
    this.setState({
      notes: '',
      next_callback: '',
      purpose: '',
      errors: {}
    });
  }

  // on add call log
  onAddCallLog = () => {
    const { history } = this.props;
    const id = history?.location?.state?.query?.id;
    const {notes, next_callback, purpose, contact_method} = this.state;
    
    const schema = yup.object().shape({
      next_callback: yup.string().required("Callback is required"),
      purpose: yup.string().required("Purpose is required"),
      contact_method: yup.string().required("Contact method is required"),
    });

    const data = {  next_callback, purpose, contact_method };
    
    schema.validate(data, { abortEarly: false }).then(() => {
      this.setState({ errors: {} });
      this.setState({loader: true});
      this.props.addCallLog({
        notes,
        next_callback,
        reason: purpose,
        user: id,
        created_by_details: {
          uuid: JSON.parse(localStorage.getItem('authUser'))?.user?.uuid
        },
        representative:JSON.parse(localStorage.getItem('authUser'))?.user?.uuid,
        contact_method
      });
      setTimeout(() =>  this.props.getCallLogList({user__uuid: id}), 1000)
      this.onClear();
    }).catch((error) => {
      let err_data = {};
      map(error.inner, (item) => {
        err_data[item.path] = item.message;
      });
      this.setState({ errors: err_data });
    });
  };

  //on deactivate lead
  onDeactivate = () => {
    const {leadData} = this.state;
    const { history } = this.props;
    const id = history?.location?.state?.query?.id;
    this.setState({loader: true});
    this.props.updateLeads({uuid: id, is_active: !leadData?.is_active, is_crm: true});
  }
  
  // render primary info
  renderPrimaryInfo = () => {
    const {leadData: customer} = this.state;
    const name = customer?.first_name ? `${customer?.first_name} ${customer?.last_name}` : '';
    let phone_numbers = '', primaryEmail = '';
    if (!isEmpty(customer?.phone_numbers)) {
      map(customer?.phone_numbers, (item) => {
        if (item?.primary) phone_numbers = item?.phone;
      })
    }

    !isEmpty(customer?.emailaddress_set) && map(customer?.emailaddress_set, (item) => {
      primaryEmail = item?.primary && !item.email.includes('doody.com') && item?.email 
    });

    let authorizedUserName = customer?.authorizedUser?.map(item => item?.user_name)

    return (
      <div className="card">
        <div className="card-title">
          <h5>Primary Information</h5>
        </div>
        <div className="card-body">
          <div className="flex flex-start mb-10">
            <div className="label">
              <b>Primary User:</b>
              <span>Authorized Users: </span>
            </div>
            <div className="value">
              <b>{name}</b>
              <span>{authorizedUserName?.join(', ')}</span>
            </div>
          </div>
          <div className="mb-10"><b>{!isEmpty(customer?.phone_numbers) ? phone_numbers ? `+1 ${this.formatPhoneNumber(phone_numbers)} (Primary)` : `+1 ${this.formatPhoneNumber(customer?.phone_numbers?.[0]?.phone)}` : ''}</b></div>
         
         
          {!customer?.is_dummy_email && 
            <div><b>{!isEmpty(customer?.emailaddress_set) ? `${primaryEmail ? primaryEmail : customer.email && !customer.email.includes('doody.com') ? customer.email  `(Primary)` : ''} ` : '-'}</b> </div>
          }          
        </div>
      </div>
    )
  };

  // render active service
  renderActiveService = (item, index) => {
    const MAP_OPTIONS = { disableDoubleClickZoom: true, zoomControl: false, mapTypeControl: false, scaleControl: false, streetViewControl: false, rotateControl: false, fullscreenControl: false };
    const dog_suffix = item?.calculated_price?.pet_count === 1 ? 'dog' : 'dogs';
    let arr = [];
    if (item?.frequency) arr.push(`${FREQUENCY_MAPPING[item?.frequency]} service`)
    if (item?.area_to_clean?.length > 0){
      let areasToClean = [];
      map(item?.area_to_clean, (ar)=>{
        areasToClean.push(`${formattedAreas[ar]?formattedAreas[ar]:ar}`)
      })
      arr.push(areasToClean.join(', '))
    } 
    if (item?.calculated_price?.pet_count > 0) arr.push(`${item?.calculated_price?.pet_count} ${dog_suffix}`)

    let one_time_total = 0, one_time_items = []
    map(item?.calculated_price?.one_time_charges
      && item?.calculated_price?.one_time_charges?.one_time_items, (a) => {
      if (a.type === 'add_on') {
        one_time_items.push(a.name)
        one_time_total += a.price
      }
    })
    let total_per_visit = item?.calculated_price?.total_price_per_service + one_time_total

    return (
      <div key={`Service${index}`}>
        {
          item?.service_address?.geo_location ?
            <div className="map">
              <GoogleMapReact
                bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY }}
                options={MAP_OPTIONS}
                defaultCenter={{ lat: item?.service_address?.geo_location?.latitude, lng: item?.service_address?.geo_location?.longitude }}
                defaultZoom={13}
              >
                <MarkerPin
                  address={item?.service_address?.address}
                  lat={item?.service_address?.geo_location?.latitude}
                  lng={item?.service_address?.geo_location?.longitude} />
              </GoogleMapReact>
            </div> : ''
        }
        <div className="card-body">
          <h5 className="sadd">{!_.isEmpty(item?.service_address) ? `${item?.service_address?.address}, ${item?.service_address?.city}, ${item?.service_address?.state} ${item?.service_address?.zip_code}` : '-'}</h5>
          <div className="active_service_list lh-21 color-252730">
            <div className="flex flex-start">
              <div className="flex-1">
                <strong className="color-22232A">Frequency</strong>
                <span className="d-block">{FREQUENCY_MAPPING[item?.frequency] && FREQUENCY_MAPPING[item?.frequency]}</span>
              </div>
              <div className="flex-1">
                <strong className="color-22232A"># of Dogs</strong>
                <span className="d-block">{item?.calculated_price?.pet_count}</span>
              </div>
            </div>
            <hr/>
            <div className="sdetail">
              <div className="subs">
                <strong className="color-22232A">Subscription</strong>
                <span className=" d-flex justify-content-between">
                  <p className="color-252730 mb-10">{arr.join(', ')}</p>
                  <strong className="color-22232A">${item?.calculated_price?.service_base_price}</strong>
                </span>
              </div>
              <div className="subs">
                <strong className="color-22232A">Add On</strong>
                <span className=" d-flex justify-content-between">
                  {one_time_items?.length > 0 ?
                    <React.Fragment>
                      <p className="color-252730 mb-10">
                        {one_time_items?.length > 0 ? `${one_time_items?.join(', ')} (First Visit)` : ''}
                      </p>
                      <strong>${one_time_total}</strong>
                    </React.Fragment> : ''}
                </span>

                <span className=" d-flex justify-content-between">
                  {item?.calculated_price?.recurring_add_ons?.recurring_addon_items?.length > 0 ?
                    <React.Fragment>
                      <p className="color-252730 mb-10">
                        {map(item?.calculated_price?.recurring_add_ons
                          && item?.calculated_price?.recurring_add_ons?.recurring_addon_items, (a) => {
                          return `${a.name}, `
                        })}
                        ({FREQUENCY_MAPPING[item?.calculated_price?.frequency]})
                      </p>
                      <strong>${item?.calculated_price?.recurring_add_ons?.total_recurring_addon_cost}</strong>
                    </React.Fragment> : '-'}
                </span>
              </div>
            </div>
            <div className="total flex px-0 pb-5">
              <strong className="color-22232A">Total Per visit</strong>
              <span className="color-22232A d-flex justify-content-between"><strong>${total_per_visit}</strong></span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // Render lead stage
  renderLeadStage = () => {
    const {leadData, currentLeadStep, enquiryList} = this.state;
    const isConvertToCustomer = enquiryList?.results?.length === 0;
    const leadLogs = [];
    map(leadData?.lead_status_logs, (obj) => {
      leadLogs[leadStage.indexOf(obj.stage)] = obj;
    })
    let contact_log = leadData?.lead_status_logs?.filter(x => x.stage === "contacted")
    contact_log = orderBy(contact_log, 'created_at', 'asc')
    let interested = leadData?.lead_status_logs?.filter(x => x.stage === "interested")
    interested = orderBy(interested, 'created_at', 'desc')

    return (
      <div>
        <Steps
          size="small"
          current={currentLeadStep}
          onChange={(current) => this.onLeadStepChange(current)}
          className="site-navigation-steps main-nav"
        >
          <Step className="current" title="New Lead" style={{"backgroundColor": currentLeadStep >= 0 ? "#F6CD31" : ""}} />
          <Step className="green" title="Contacted" style={{"backgroundColor": currentLeadStep >= 1 ? "#ED9B16" : ""}} />
          <Step className="red" title="Interested" style={{"backgroundColor": currentLeadStep >= 2 ? "#ABC318" : ""}} />
        </Steps>
        <div className={"flex flex-start"}>
          {currentLeadStep >= 0 ? <div className={"flex-1 txt-blck"}>
            <span className="d-block">{leadData?.created_at ? moment(leadData.created_at).format('MMM DD, YYYY') : moment().format('MMM DD, YYYY')}</span>
            <span>{leadData?.outreach ? outreach[leadData?.outreach] : ''}</span>
          </div> : <div />}
          {currentLeadStep >= 1 ? <div className={"flex-1 txt-blck"}>
            <span className="d-block">{`Contacted ${(contact_log[0] && contact_log[0].created_at) ? moment(contact_log[0].created_at).format('MMM DD, YYYY') : moment().format('MMM DD, YYYY')}\nby ${contact_log[0]?.contacted_by?.first_name || ''}`}</span>
          </div> : <div /> }
          {currentLeadStep >= 2 ? <div className={"flex-1 txt-blck"}>
            <span className="d-block">{`Interested ${(interested[0] && interested[0].created_at) ? moment(interested[0].created_at).format('MMM DD, YYYY') : moment().format('MMM DD, YYYY')}\nby ${interested[0]?.contacted_by?.first_name || ''}`}</span>
          </div> : <div />}
          <div className="flex-1 txt-blck">
            {currentLeadStep === 0 && <button className="btn" onClick={() => this.onLeadStepChange(1)}>Moved to Contacted</button>}
            {currentLeadStep === 1 && <button className="btn" onClick={() => this.onLeadStepChange(2)}>Moved to Interested</button>}
            {currentLeadStep === 2 && <button
              disabled={isConvertToCustomer}
              className={`btn ${isConvertToCustomer ? 'disabled' : 'btn-primary'}`}
              onClick={() => this.onLeadStepChange(3)}>Converted to Customer</button>}
          </div>
        </div>
                 
        {currentLeadStep >= 3 ? <span>{''}</span> : <div />}
        <span className="success mt-10"><b>{leadData?.is_active ? 'if this user no longer interested,' : 'if this user is interested,'} <a href="/#" onClick={(e) => {e.preventDefault(); this.onDeactivate()}}><u>{leadData?.is_active ? 'Deactivate Lead' : 'Activate Lead'}</u></a></b></span>
      </div>
    )
  };

  // Render Source & Attribution
  renderSourceAndAttribution = () => {
    const {leadData} = this.state;
    const temp = aboutUsData.filter(item => leadData?.hear_about_us?.includes(item.value)).map(item2 => {return item2.name}).join(', ');
    const formatted_outreach = leadData?.outreach ? convertFirstCharToUppercase(leadData?.outreach) : '-';
    const formatted_attribution = leadData?.channel_attribution && leadData?.channel_attribution?.name !== 'Unknown' ? convertFirstCharToUppercase(leadData?.channel_attribution.name) : '-';

    return (
      <div className="card">
        <div className="card-title">
          <h5>Source & Attribution</h5>
        </div>
        <div className="card-body">
          <div className="label" style={{display: "flex"}}>
            <span>Outreach:</span>
            <b style={{marginLeft: "5px"}}>{formatted_outreach}</b>
          </div>
          <div className="value" style={{display: "flex"}}>
            <span>How do you hear about us:</span>
            {
              leadData?.hear_about_us?.length > 0 ?
                <b style={{marginLeft: "5px"}}>{temp}</b>
                : null
            }
          </div>
          <div className="label" style={{display: "flex", maxWidth: "none"}}>
            <span>Attribution:</span>
            <b style={{marginLeft: "5px"}}>{formatted_attribution}</b>
          </div>
        </div>
      </div>
    );
  };

  // render call log detail
  renderCallLogs = () => {
    const {callLog, next_callback, notes, purpose, errors, contact_method} = this.state;
    return (
      <div className={"card call-history mt-20"}>
        <div className="card-title">
          <h5>Scheduled and Past Contacts</h5>
        </div>
        <Table
          rowKey={record => record?.uuid}
          dataSource={callLog?.results}
          columns={DataTable.leadCallHistoryColumns()}
          pagination={false}
          onChange={this.onCallHistoryTableChange}
          className="customer-list"
        />
        <div className={"form-group mt-10"}>
          <div className="fitem half-fitem">
            <div className="fitem half-fitem tname">
              <label htmlFor="date">Date</label>
              <DatePicker
                id={"date"}
                name='next_callback'
                showTime
                minuteStep={15}
                use12Hours
                inputReadOnly
                placeholder={'Date'}
                format={"Do MMM, h:mm A"}
                value={next_callback ? moment(next_callback, 'Do MMM, h:mm A') : null}
                onChange={(e) => this.onTextChange({target: {name: 'next_callback', value: e}})} />
              {errors?.['next_callback'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['next_callback']}</label> : ''}
            </div>         
          
            <div className="fitem half-fitem tname">
              <label htmlFor="purpose">Purpose of Callback</label>
              <input
                id="purpose"
                name="purpose"
                type="text"
                placeholder={"Purpose"}
                value={purpose}
                onChange={(e) => this.onTextChange(e)} />
              {errors?.['purpose'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['purpose']}</label> : ''}
            </div>        
         
            <div className="fitem half-fitem tadd">
              <label htmlFor="notes">Notes</label>
              <input
                id="notes"
                name="notes"
                type="text"
                placeholder={"Note for the call center"}
                value={notes}
                onChange={(e) => this.onTextChange(e)} />
              {errors?.['notes'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['notes']}</label> : ''}
            </div>

            <div className="fitem half-fitem tadd">
              <label htmlFor="notes">Contact Method</label>
              <Select
                className="filter_type"
                placeholder="Contact Method"
                value={contact_method ? contact_method : null}
                onChange={(e) => this.onTextChange({target: {name: 'contact_method', value: e}})}
              > <Option value="Email">Email</Option>
                <Option value="Phone">Phone</Option>
                <Option value="Text">Text</Option>
                <Option value="Chat">Chat</Option>
              </Select>
              {errors?.['contact_method'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['contact_method']}</label> : ''}
            </div>
          </div>       
        </div>
        <div className="btn-group">
          <button
            className={`btn btn-warning`}
            // disabled={disabled}
            onClick={() => this.onAddCallLog()}>Add Callback Request</button>
        </div>
      </div>
    )
  };

  // render basic detail
  renderBasicDetails = () => {
    const { leadData: customer } = this.state;
    let contact_log = customer?.lead_status_logs?.filter(x => x.stage === "contacted")
    contact_log = orderBy(contact_log, 'created_at', 'asc')

    const basicDetail = [
      { key: 'Franchise', value: customer?.field_office?.name ? customer?.field_office.name : customer?.field_office },
      { key: 'Outreach', value: `${outreach[customer?.outreach]}` },
      { key: 'First Contacted', value: (contact_log[0] && contact_log[0].created_at) ? moment(contact_log[0].created_at).format('MMM DD, YYYY') : '' }
    ]

    return map(basicDetail, (item, index) =>
      <div key={`basic${index}`} className={"dcell"}>
        <span><b>{item?.key}</b></span>
        <span>{item?.value}</span>
      </div>
    )
  };
  
  expandCollapse = (isExpand) => {
    this.setState({
      isExpandPanel: isExpand
    })
  }

  render () {
    const { leadData, loader, enquiryList, showSidebar, isExpandPanel } = this.state;
    const { history } = this.props;
    const id = history?.location?.state?.query?.id;
    const name = leadData?.first_name ? `${leadData?.first_name} ${leadData?.last_name}` : '';

    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header placeholder={'Acc Number, Customer Name, Address(Billing), Phone Number, Email Address'} disabled={true} />

          {/* Sidebar */}
          <Sidebar />

          <div className="container">
            {loader && <Loader />}
            <div className="md-container">
              <div className="filter_wrapper">
                <ul className="breadcrumb">
                  <li className={"cursor_pointer"}><span onClick={() => this.props.history.push(`/residential`, { query: { 'tab': 'lead'}})}>Leads</span></li>
                  <li><span>{name}</span></li>
                </ul>
              </div>
              <div className="residential-wrapper">
                <div className="res-head pb-0">
                  <div className="flex ai-center mb-20">
                    <div className="user-info">
                      <h3>{name}</h3>
                      <span className="">
                        {leadData?.account_number || ''}
                      </span>
                    </div>

                    <div className="user-detail">
                      {this.renderBasicDetails()}
                    </div>
                  </div>
                </div>
                <div className="res-body">
                  <div className="block-row">
                    <div className="aside-area pt-0">
                      {loader && <Loader />}
                      <aside className="laside">                        
                        {this.renderPrimaryInfo()}
                        <div className="card mt-10">
                          <div className="card-title flex">
                            {enquiryList?.results?.length > 0 ? <h5>Enquired Services</h5> : ''}
                            <button
                              className="btn btn-warning"
                              onClick={() => this.props.history.push('/residential/lead/new-service', { query: {'id': id} })}
                            >{enquiryList?.results?.length > 0 ? 'Edit Quote' : 'Quote New Service'}</button>
                          </div>
                          {map(enquiryList?.results, this.renderActiveService)}
                        </div>
                      </aside>
                      <div className="main p-0">
                        <div className="card">
                          <div className="card-body">
                            {this.renderLeadStage()}
                          </div>
                        </div>
                        {this.renderSourceAndAttribution()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {showSidebar && !isExpandPanel ? <div className="side-drawer-collapsed">
              <CustomerDrawerCollapse
                expandCollapse={this.expandCollapse}
              />
            </div> : ''}
            {showSidebar && isExpandPanel ? <div className="side-drawer rdrawer-expanded">
              <CustomDrawer
                customerId={id}
                CallLog={this.props.CallLog}
                getCallLogList={this.props.getCallLogList}
                RepresentativeList={this.props.RepresentativeList} // reducer
                getRepresentativeList={this.props.getRepresentativeList}
                addCallLog={this.props.addCallLog}
                updateCallLog={this.props.updateCallLog}
                getAccountNotes={this.props.getAccountNotes}
                addAccountNotes={this.props.addAccountNotes}
                accountNotes={this.props.AccountNotes}
                expandCollapse={this.expandCollapse}
              />
            </div> : ''}
          </div>
        </div>
      </div>
    )
  }
}

export default LeadDetail;
